// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Dw1s","dragIcon":"SortableItem_dragIcon__39dXO","disabled":"SortableItem_disabled__2_0_f"};